import { Language } from '../localization/i18n'

import { AppVariant, EventDifficultyLevel, EventType } from './App.types'

export const CLASSNAME_CONTAINED_CONTENT = 'w-full max-w-7xl my-0 mx-auto'

export enum AuthRoutes {
  LOGIN = '/auth/',
  REGISTER = '/auth/register',
  FAMILY_ACCOUNT_DISCLAIMER = '/auth/family-account-disclaimer',
  FAMILY_ACCOUNT_MEMBER_CREATION = '/auth/family-account-member-creation',
}

export enum FooterRoutes {
  PRIVACY = '/h/privacy',
  TERMS = '/h/terms',
}

export const WIDGET_ROUTE = '/widget/w'

export enum WidgetUserRoutes {
  MY_VIDEOS = '/user/videos',
  MY_PRODUCTS = '/user/products',
  MY_BOOKINGS = '/user/bookings',
  MY_DETAILS = '/user/details',
}

export enum MyBookingsView {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

export enum WidgetListParam {
  MY_DETAILS = 'profile',
  MY_BOOKINGS = 'bookings',
  MY_PRODUCTS = 'products',
  MY_VIDEOS = 'userRecordings',
}

export const EventDifficultyLevelToNameMapping: {
  [key in EventDifficultyLevel]: 'beginner' | 'intermediate' | 'professional' | 'all-levels'
} = {
  [EventDifficultyLevel.BEGINNER]: 'beginner',
  [EventDifficultyLevel.INTERMEDIATE]: 'intermediate',
  [EventDifficultyLevel.PROFESSIONAL]: 'professional',
  [EventDifficultyLevel.ALL]: 'all-levels',
} as const

export const EventTypeToNameMapping: {
  [key in EventType]:
    | 'camp'
    | 'class'
    | 'course'
    | 'education'
    | 'event'
    | 'open-training'
    | 'private'
    | 'retreat'
    | 'training'
    | 'workshop'
} = {
  [EventType.CAMP]: 'camp',
  [EventType.CLASS]: 'class',
  [EventType.COURSE]: 'course',
  [EventType.EDUCATION]: 'education',
  [EventType.EVENT]: 'event',
  [EventType.OPENTRAINING]: 'open-training',
  [EventType.PRIVATE]: 'private',
  [EventType.RETREAT]: 'retreat',
  [EventType.TRAINING]: 'training',
  [EventType.WORKSHOP]: 'workshop',
}

export const StoreBadgeLink = (language: Language): { [key in AppVariant]: string } => ({
  [AppVariant.PLAYSTORE]: `https://play.google.com/store/apps/details?id=at.eversport&hl=${language}`,
  [AppVariant.APPSTORE]: `https://itunes.apple.com/app/eversport-now/id946460861`,
})
